module.exports = __webpack_public_path__ + "static/img/virtuspay-logo.c06b9770.png";